import React, { FC, ReactElement } from 'react'
import { onKeyboardClick } from '@/utils/a11y/keyboard-click'

const LightningIcon: FC<{
	className?: string
	width?: number
	height?: number
	onClick?: () => void
}> = (props): ReactElement => {
	return (
		<svg
			onClick={props.onClick}
			viewBox="0 0 56 56"
			fill="none"
			className={props.className}
			width={props.width}
			height={props.height}
			role={props.onClick ? "button" : undefined}
			tabIndex={props.onClick ? 0 : undefined}
			onKeyDown={onKeyboardClick(props.onClick)}
		>
			<rect x="4" y="4" width="48" height="48" rx="24" fill="#F4EBFF" />
			<path
				d="M29 18L19 30H28L27 38L37 26H28L29 18Z"
				stroke="#7F56D9"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<rect x="4" y="4" width="48" height="48" rx="24" stroke="#F9F5FF" strokeWidth="8" />
		</svg>
	)
}

export default LightningIcon
